import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  QueryList,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { MapService, SupplierInboxJobsService, UserService } from '../../../services';
import crossfilter from 'crossfilter2/crossfilter';
import { JobStatus } from '../../../enums/job-status';
import { IFacetedInboxTask, IFacetedJob } from '../../../interfaces/faceted-inbox-task';
import { SelectItem } from 'primeng/api';
import { VmeInboxJobsService, VehicleAddressService } from '../../../services';
import { ITaskInfo } from '../../../interfaces/task-info';
import { get, orderBy } from 'lodash';
import { CanComponentDeactivate } from '../../../guards/pending-changes.guard';
import { Observable } from 'rxjs';
import moment from 'moment';
import { Table } from 'primeng';
import { Router } from '@angular/router';

@Component({
  selector: 'supplier-interactive-schedule',
  templateUrl: './supplier-interactive-schedule.component.html',
  styleUrls: [
    './supplier-interactive-schedule.component.scss',
    '../../jobs-inbox/vme-jobs-faceted-filtering.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SupplierInteractiveScheduleComponent
  implements OnInit, CanComponentDeactivate, AfterViewChecked
{
  showFilters: boolean = true;
  sortByAscending = true;
  filterWatched: boolean = false;
  filterCount = 0;

  @HostListener('window:beforeunload')
  confirm(): boolean | Observable<boolean> {
    return this.pendingChanges == 0;
  }

  showSide = true;
  supplierIds: number[];
  selectedFilters: any[] = [];
  rowsInPage: number = 999;
  firstRow: number = 0;
  sortField: string;
  settingFilters: boolean = false;
  sortOrder: number = 0;
  staticMapSize = '300x200';
  resultSet: IFacetedInboxTask[]; // the rows shown in the paginated grid
  inputTasks: ITaskInfo[] = [];

  public userLongitude: {} = {};
  public userLatitude: {} = {};

  public userLocation: {} = {};
  isFacetLoading: {} = {};

  filterDefinitions: any[] = [
    {
      propertyName: 'supplierWatched',
      title: 'Watchlist',
      searchable: false,
    },
    {
      propertyName: 'supplierDirected',
      title: 'Directed To You',
      searchable: false,
    },
    {
      propertyName: 'customerTaskType',
      title: 'Move Type',
    },
    {
      propertyName: 'scheduledDate',
      title: 'Scheduled Date',
      isDate: true,
    },
    {
      propertyName: 'latestPickupDate',
      title: 'Latest Collection',
      isDate: true,
      noRangeCheck: true,
    },
    {
      propertyName: 'latestDropOffDate',
      title: 'Latest Delivery',
      isDate: true,
      noRangeCheck: true,
    },
    {
      propertyName: 'pickupAreaName',
      title: 'Pickup Region',
      searchable: true,
    },
    {
      propertyName: 'deliveryAreaName',
      title: 'Delivery Region',
      searchable: true,
    },
    {
      propertyName: 'pickupZoneName',
      title: 'Collection Area',
      searchable: true,
    },
    {
      propertyName: 'deliveryZoneName',
      title: 'Delivery Area',
      searchable: true,
    },
    /*
    {
      propertyName: "checklistCategoryName", title: "Checklist Category", searchable: true
    },
    {
      propertyName: "checklistSubCategoryName", title: "Checklist SubCategory Area", searchable: true
    },
     */
    {
      propertyName: 'vehicleRegDetails',
      title: 'Vehicle',
      searchable: true,
    },
    {
      propertyName: 'moveDistance',
      title: 'Journey Length',
      ranges: [
        { min: 0, max: 10, groupValue: 1, label: 'Up to 10 miles' },
        { min: 10, max: 20, groupValue: 2, label: '10 - 20 miles' },
        { min: 20, max: 50, groupValue: 3, label: '20 - 50 miles' },
        { min: 50, max: 100, groupValue: 4, label: '50 - 100 miles' },
        { min: 100, max: 200, groupValue: 5, label: '100 - 200 miles' },
        { min: 200, max: 300, groupValue: 6, label: '200 - 300 miles' },
        { min: 300, max: 400, groupValue: 7, label: '300 - 400 miles' },
        { min: 400, max: 10000, groupValue: 8, label: '400+ miles' },
      ],
    },
    {
      propertyName: 'vehicleWeight',
      title: 'Weight Category',
      ranges: [
        { min: 1, max: 3500, groupValue: 1, label: 'Less than 3.5t' },
        { min: 3500, max: 7500, groupValue: 3.5, label: '3.5t - 7.5t' },
        { min: 7500, max: 18000, groupValue: 7.5, label: '7.5t - 18t' },
        { min: 18000, max: 44000, groupValue: 18, label: '18t - 44t' },
      ],
    },
    {
      propertyName: 'pickupDistance1',
      title: 'Pickup Distance from',
      placeholder: 'Postcode/Town',
      input: true,
      ranges: [
        { min: null, max: null, groupValue: 1, label: 'N/A' },
        { min: 0, max: 10, groupValue: 2, label: 'Up to 10 miles' },
        { min: 10, max: 20, groupValue: 3, label: '10 - 20 miles' },
        { min: 20, max: 50, groupValue: 4, label: '20 - 50 miles' },
        { min: 50, max: 100, groupValue: 5, label: '50 - 100 miles' },
        { min: 100, max: 200, groupValue: 6, label: '100 - 200 miles' },
        { min: 200, max: 300, groupValue: 7, label: '200 - 300 miles' },
        { min: 300, max: 400, groupValue: 8, label: '300 - 400 miles' },
        { min: 400, max: 10000, groupValue: 9, label: '400+ miles' },
      ],
    },
    {
      propertyName: 'dropoffDistance1',
      title: 'Dropoff Distance from',
      placeholder: 'Postcode/Town',
      input: true,
      ranges: [
        { min: null, max: null, groupValue: 1, label: 'N/A' },
        { min: 0, max: 10, groupValue: 2, label: 'Up to 10 miles' },
        { min: 10, max: 20, groupValue: 3, label: '10 - 20 miles' },
        { min: 20, max: 50, groupValue: 4, label: '20 - 50 miles' },
        { min: 50, max: 100, groupValue: 5, label: '50 - 100 miles' },
        { min: 100, max: 200, groupValue: 6, label: '100 - 200 miles' },
        { min: 200, max: 300, groupValue: 7, label: '200 - 300 miles' },
        { min: 300, max: 400, groupValue: 8, label: '300 - 400 miles' },
        { min: 400, max: 10000, groupValue: 9, label: '400+ miles' },
      ],
    },
  ];

  showSearch = false;
  filterGroups: any[] = [];
  private allData: IFacetedInboxTask[];
  private filterDimensions: any[];
  private crossFilterData: any;
  isLoading: boolean;
  workingSet: IFacetedInboxTask[] = [];
  showLogging: any;
  sortType: boolean[] = [];
  refreshTableSearchFilter: boolean = false;
  isFacetOpen: {} = {};
  selectedJobs: IFacetedJob[] = [];

  @ViewChildren('facetTable') facetTables: QueryList<Table>;
  loadingSelection: boolean = false;
  pendingChanges: number = 0;
  loadingMap: {} = {};
  mapCode: {} = {};
  showingMap: {} = {};
  sortby: number = 2;
  updatePending = 0;

  constructor(
    private router: Router,
    private userService: UserService,
    private changeDetectorRef: ChangeDetectorRef,
    private supplierInboxjobsService: SupplierInboxJobsService,
    private mapService: MapService,
    private vehicleAddressService: VehicleAddressService,
    private vmeInboxjobsService: VmeInboxJobsService,
  ) {
    this.userService.getCurrentUserOrg().then((organisation) => {
      this.supplierIds = [organisation.id];
    });
  }

  ngOnInit() {
    this.load().then((x) => {});
  }

  ngAfterViewChecked() {
    if (this.refreshTableSearchFilter) {
      for (let index = 0; index < this.filterDefinitions.length; index++) {
        if (this.filterDefinitions[index].tableFilter) {
          let tf = this.filterDefinitions[index].tableFilter;
          let facetTable = this.facetTables.toArray()[index];

          facetTable.filter(tf.value, tf.field, tf.method);
        }
      }

      this.refreshTableSearchFilter = false;
      this.populateWorkingSet();
    }
  }

  async load() {
    this.filterGroups = [];
    this.filterDimensions = [];
    this.isLoading = true;

    // Get the types of movement this supplier can do
    this.allData = await this.vmeInboxjobsService.facetedJobSearch({
      notOnHold: true,
      jobStatus: JobStatus.Created,
      hasSupplier: false,
      checkSupplierCapability: true,
    });

    this.updateFacets();
  }

  getWorkingSetCountAsTotalJobs(): number {
    const distinctItems = Array.from(
      new Map(this.workingSet.map((item) => [item.jobId, item])).values(),
    );
    return distinctItems.length;
  }

  filterRowSelectionChanged(index: number) {
    this.loadingSelection = true;

    this.clearDimensions();
    this.setDimensionFilter(index);
    this.populateWorkingSet();

    this.loadingSelection = false;
  }

  handleFilter(event, total) {}

  setResults() {
    let seq = 0;

    this.resultSet = this.workingSet
      .sort((a, b) => {
        if (this.sortby == 1) {
          if (this.sortByAscending) {
            return a.moveDistance - b.moveDistance;
          }
          return b.moveDistance - a.moveDistance;
        }

        if (this.sortby == 2) {
          if (this.sortByAscending) {
            return this.dateSort(b.scheduledDate, a.scheduledDate);
          }
          return this.dateSort(a.scheduledDate, b.scheduledDate);
        }

        if (this.sortby == 4) {
          if (this.sortByAscending) {
            return this.dateSort(b.orderCreatedDate, a.orderCreatedDate);
          }
          return this.dateSort(a.orderCreatedDate, b.orderCreatedDate);
        }

        if (this.sortByAscending) {
          return a.buyItNowPrice - b.buyItNowPrice;
        }
        return b.buyItNowPrice - a.buyItNowPrice;
      })
      .slice(this.firstRow, this.firstRow + this.rowsInPage);

    this.resultSet.forEach((x) => (x.sequence = ++seq));

    // clear all filters if no results (can happen with data changes)
    if (this.resultSet.length == 0) {
      this.clearAllFilters();
    }
  }

  sortFilter(index: number) {
    this.sortType[index] = !this.sortType[index];
    let filterGroup = this.filterGroups[index];

    if (this.sortType[index]) {
      filterGroup.selectItems = orderBy(
        filterGroup.selectItems,
        (o) => {
          return o.count;
        },
        'desc',
      );
    } else {
      filterGroup.selectItems = orderBy(
        filterGroup.selectItems,
        (o) => {
          return o.value;
        },
        'asc',
      );
    }

    // set selecteditem positions to top of array
    this.orderSelectedUnselectedItems(index);

    this.resetSelectedItems(index);
  }

  dateSort(a, b): number {
    if (this.sortOrder == 1) return moment(a).unix() - moment(b).unix();
    else return moment(b).unix() - moment(a).unix();
  }

  clearAllFilters(selections = null) {
    this.settingFilters = true;
    this.selectedJobs = [];
    this.inputTasks = [];

    setTimeout(() => {
      // Call setTimeout to run code asynchronously
      this.selectedFilters.fill(null);
      this.clearDimensions();

      this.populateWorkingSet();

      this.changeDetectorRef.detectChanges();
      this.settingFilters = false; // Reset before leaving callback method

      if (selections) {
        this.selectedFilters = selections;
        this.setFiltersFromSelection();
      }
    }, 10);
  }

  setFiltersFromSelection() {
    this.settingFilters = true;

    setTimeout(() => {
      // Call setTimeout to run code asynchronously
      for (let i = 0; i < this.selectedFilters.length; i++) {
        this.setDimensionFilter(i);
        this.resetSelectedItems(i);
      }
      this.populateWorkingSet(false);

      this.settingFilters = false; // Reset before leaving callback method
    }, 10);
  }

  setDimensionFilter(index: number) {
    //flatten the values in the selection array
    const selectedFilter = get(this.selectedFilters, `[${index}]`);
    const selectedFilterValues =
      selectedFilter && typeof selectedFilter.map === 'function'
        ? selectedFilter.map((x) => {
            return x.value;
          })
        : [];

    if (selectedFilterValues && selectedFilterValues.length > 0) {
      let definition = this.filterDefinitions[index];
      if (!definition) return;

      if (!definition.rangeDivisor && !definition.dateDiff && !definition.ranges) {
        if (!definition.isDate) {
          this.filterDimensions[index].filterFunction((dv) => {
            return selectedFilterValues.indexOf(dv) >= 0;
          });
        } else {
          this.filterDimensions[index].filterFunction((x) => {
            return selectedFilterValues.indexOf(x.toISOString()) >= 0;
          });
        }
      } else if (definition.rangeDivisor) {
        this.filterDimensions[index].filterFunction((d) => {
          selectedFilterValues.forEach((value) => {
            let min = value - (definition.rangeDivisor - 1);
            let max = value + 1;

            const result = d >= min && d <= max;
            if (result) return result;
          });

          return false;
        });
      } else if (definition.dateDiff) {
        this.filterDimensions[index].filterFunction((x) => {
          let today = moment().startOf('day');
          let xDate = moment(x).startOf('day');
          let days = xDate.diff(today, 'days');

          return selectedFilterValues.indexOf(days) >= 0;
        });
      } else if (definition.ranges) {
        this.filterDimensions[index].filterFunction((x) => {
          let result: boolean = false;

          // get min and max range from value 1
          for (let i = 0; i < definition.ranges.length; i++) {
            let range = definition.ranges[i];

            //this.selectedFilters[index].value == range.groupValue;

            result =
              ((x >= range.min && x < range.max) || (range.min == x && range.max == x)) &&
              selectedFilterValues.indexOf(range.groupValue) >= 0;

            if (result) break;
          }

          return result;
        });
      }
    } else if (this.filterDimensions[index]) {
      this.filterDimensions[index].filterAll();
    }

    this.refreshTableSearchFilter = true;
  }

  clearDimensions() {
    for (let i = 0; i < this.filterDimensions.length; i++) {
      if (!this.selectedFilters[i]) this.filterDimensions[i].filterAll();
    }
  }

  setDimensions() {
    let nullData = 'Not set';
    let nullDataNumber = 0;

    for (let i = 0; i < this.filterDefinitions.length; i++) {
      let def = this.filterDefinitions[i];

      this.filterDimensions[i] = this.crossFilterData.dimension((d) => {
        return (
          (def.isDate ? moment(d[def.propertyName]).startOf('day') : d[def.propertyName]) ||
          (def.ranges ? nullDataNumber : nullData)
        );
      });
    }

    this.setSelections();
  }

  populateWorkingSet(saveSelection: boolean = true) {
    // reset groups according to filtered dimensions
    this.setSelections();

    // repopulate the results grid using the selected dimension filters
    this.workingSet = this.crossFilterData.allFiltered();

    this.firstRow = 0;
    this.setResults();

    if (saveSelection) {
      this.saveToStorage();
    }
  }

  saveToStorage() {
    localStorage.setItem('supplier-interactive-schedule', JSON.stringify(this.selectedFilters));
  }

  setSelections() {
    for (let i = 0; i < this.filterDefinitions.length; i++) {
      let definition = this.filterDefinitions[i];
      let data: any;
      if (!definition.rangeDivisor && !definition.dateDiff && !definition.ranges) {
        data = this.filterDimensions[i].group().all();
      } else if (definition.rangeDivisor) {
        data = this.filterDimensions[i]
          .group((x) => {
            let val = Math.ceil((x || 0) / definition.rangeDivisor) * definition.rangeDivisor;
            return val || 1;
          })
          .all();
      } else if (definition.dateDiff) {
        data = this.filterDimensions[i]
          .group((x) => {
            let today = moment().startOf('day');
            let xDate = moment(x).startOf('day');
            let days = xDate.diff(today, 'days');

            return days;
          })
          .all();
      } else if (definition.ranges) {
        data = this.filterDimensions[i]
          .group((x) => {
            let val = x || 1;
            let groupVal: number = undefined;

            for (let k = 0; k < definition.ranges.length; k++) {
              let range = definition.ranges[k];

              if (val >= range.min && val <= range.max) {
                groupVal = range.groupValue;
                break;
              }
            }

            if (!groupVal) {
              return val;
            } else {
              return groupVal;
            }
          })
          .all();
      }

      let dataArray = data.filter(
        (x) =>
          x.value > 0 ||
          (this.selectedFilters[i]
            ? this.selectedFilters[i]
                .map((x) => {
                  return x.value;
                })
                .indexOf(x.key) >= 0
            : false),
      );

      this.filterGroups[i] = {
        name: definition.title,
        data: dataArray,
        noRangeCheck: definition.noRangeCheck,
        facetOpen: true,
        selectItems: dataArray.map((x) => {
          if (!definition.rangeDivisor && !definition.ranges) {
            let lbl: string = x.key;

            if (definition.isDate) {
              lbl = moment(x.key).startOf('day').format('ddd DD MMM YYYY');
            } else if (definition.dateDiff) {
              lbl = `${x.key} days`;
            }

            return {
              label: lbl,
              count: x.value,
              value: definition.isDate ? moment(x.key).startOf('day').toISOString() : x.key,
            } as SelectItem;
          } else if (definition.rangeDivisor) {
            let numVal = parseFloat(x.key);

            // calculate label by value
            if (numVal <= definition.rangeDivisor) {
              return {
                label: `Up to ${definition.rangeDivisor}${definition.descriptor}`,
                count: x.value,
                value: x.key,
              } as SelectItem;
            } else {
              let min = numVal;
              let max = numVal + definition.rangeDivisor;
              let lbl = `${min}-${max}${definition.descriptor}`;

              return {
                label: lbl,
                count: x.value,
                value: x.key,
              } as SelectItem;
            }
          } else if (definition.ranges) {
            for (let j = 0; j < definition.ranges.length; j++) {
              if (definition.ranges[j].groupValue == x.key) {
                return {
                  label: definition.ranges[j].label,
                  count: x.value,
                  value: x.key,
                } as SelectItem;
              }
            }

            return {
              label: x.key,
              count: x.value,
              value: x.key,
            } as SelectItem;
          }
        }),
      };

      if (!this.filterGroups[i].noRangeCheck) {
        this.filterGroups[i].selectItems.forEach((x) => {
          x.dataOutOfRange = this.dataOutOfRange(x);
        });
      }

      this.resetSelectedItems(i);

      // add the selected items at top of list then the unselected
      this.orderSelectedUnselectedItems(i);
    }

    this.countFiltersSelected();
  }

  countFiltersSelected() {
    this.filterCount = this.selectedFilters.reduce((acc, innerArr) => acc + innerArr.length, 0);
  }

  orderSelectedUnselectedItems(index: number) {
    let reordered = [];
    let selectedFilters = this.filterGroups[index].selectItems.filter((x) =>
      this.selectedFilters[index] ? this.selectedFilters[index].indexOf(x) >= 0 : false,
    );
    let unselectedFilters = this.filterGroups[index].selectItems.filter((x) =>
      this.selectedFilters[index] ? this.selectedFilters[index].indexOf(x) == -1 : false,
    );

    reordered.push(...selectedFilters, ...unselectedFilters);

    this.filterGroups[index].selectItems = reordered;
  }

  resetSelectedItems(i: number) {
    // reset selected items to reflect current filter
    let resetItems = [];

    for (let j = 0; j < this.filterGroups[i].selectItems.length; j++) {
      let item = this.filterGroups[i].selectItems[j];

      if (this.selectedFilters[i] && typeof this.selectedFilters[i].forEach === 'function') {
        this.selectedFilters[i].forEach((x) => {
          if (x.value == item.value) {
            resetItems.push(item);
          }
        });
      }
    }

    this.selectedFilters[i] = resetItems;

    //    if (!(i in this.isFacetOpen)) {
    //      this.isFacetOpen[i] = resetItems.length > 0;
    //    }
  }

  dataOutOfRange(data): boolean {
    let format = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
    let date = moment(data.value, format, true);
    let isDate = date.isValid();

    if (isDate) {
      return date < moment().subtract(1, 'd');
    } else if (this.isNumeric(data.value)) {
      return data.value < 0;
    }

    return false;
  }

  isNumeric(num) {
    num = '' + num; //coerce num to be a string
    let result = !isNaN(num) && !isNaN(parseFloat(num));
    return result;
  }

  isJobSelected(jobId: number) {
    return this.selectedJobs.find((x) => x.jobId == jobId) != undefined;
  }

  getSelectedFiltersString(i: number) {
    return this.selectedFilters[i]
      .map(
        (x) =>
          '<div style="margin-top: 0px; margin-bottom: 4px; padding-top: 0px; padding-bottom: 4px; border-bottom: 1px solid #666;">' +
          x.label +
          '</div>',
      )
      .join('');
  }

  applyFilter(tableIndex: number, value: string, field: string, method): void {
    let facetTable = this.facetTables.toArray()[tableIndex];

    facetTable.filter(value, field, method);

    // store the filter in the definitions array so it can be reapplied when filters are refreshed
    this.filterDefinitions[tableIndex].tableFilter = { value, field, method };
  }

  async showMap(event, i, t) {
    event.stopPropagation();

    this.showingMap[i] = !this.showingMap[i];

    if (this.showingMap[i]) {
      this.loadingMap = true;
      const code = await this.getMap(t);
      this.mapCode[i] = code;
      this.loadingMap = false;
    }
  }

  async getMap(t) {
    const polylines = await this.mapService.GetRoutePolyLine({
      fromLatitude: t.fromLatitude,
      fromLongitude: t.fromLongitude,
      toLatitude: t.toLatitude,
      toLongitude: t.toLongitude,
      departureTime: t.earliestPickupDate,
    });

    const task = {
      pickupLocation: { latitude: t.fromLatitude, longitude: t.fromLongitude },
      dropoffLocation: { latitude: t.toLatitude, longitude: t.toLongitude },
    } as ITaskInfo;

    return this.mapService.getStaticMapPath(
      'roadmap',
      this.mapService.buildMarkersFromTask(task),
      this.staticMapSize,
      1,
      null,
      [polylines],
    );
  }

  selectedJobChanged(data) {
    const exists = this.selectedJobs.find((x) => x.jobId == data.jobId);
    if (exists != null) {
      this.selectedJobs = this.selectedJobs.filter((x) => x.jobId != data.jobId);
    } else {
      this.selectedJobs.push({
        jobId: data.jobId,
        supplierId: data.supplierId,
      });

      // Force Angular update
      this.selectedJobs = [...this.selectedJobs];
      this.showFilters = false; // So we can see the job in the diary view
    }
  }

  linkedJob(task) {
    // Is there a task subsequent to this one in this job
    return (
      this.resultSet.filter((x) => x.jobId == task.jobId && x.sequence > task.sequence).length > 0
    );
  }

  linkedToPrevious(task) {
    if (this.resultSet.filter((x) => x.jobId == task.jobId).length > 1) {
      //console.log("Result Set ", this.resultSet);
      //console.log("Task ", task);
    }

    // Is there a task previous to this one in this job
    return (
      this.resultSet.filter((x) => x.jobId == task.jobId && x.sequence < task.sequence).length > 0
    );
  }

  hideResults() {
    this.showSearch = true;
    this.selectedJobs = [];
  }

  changesUpdate($event: number) {
    this.pendingChanges = $event;
  }

  inputJobsUpdate($event: any) {
    this.selectedJobs = $event;
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  viewJob(jobId: any) {
    window.open('/app/jobscreen/' + jobId, '_blank');
  }

  applyInput(i: number, value: any) {
    const propertyName = this.filterDefinitions[i].propertyName;

    if (
      propertyName == 'pickupDistance1' ||
      propertyName == 'pickupDistance2' ||
      propertyName == 'dropoffDistance1' ||
      propertyName == 'dropoffDistance2'
    ) {
      this.isFacetLoading[i] = true;

      if (value.length > 0) {
        this.vehicleAddressService.GetVehicleAddress(value).then((x) => {
          this.applyInputUpdated(x, i, propertyName, value);
        });
      } else {
        this.applyInputUpdated(null, i, propertyName, value);
      }
    }
  }

  applyInputUpdated(x, i, propertyName, value) {
    this.userLatitude[propertyName] = x && x.latitude ? x.latitude : null;
    this.userLongitude[propertyName] = x && x.longitude ? x.longitude : null;
    this.userLocation[propertyName] = value;
    this.updateFacets();
    this.isFacetOpen[i] = true;
    this.isFacetLoading[i] = false;
  }

  updateFacets() {
    this.updateDistances();

    this.crossFilterData = crossfilter(this.allData);
    this.workingSet = this.crossFilterData.allFiltered();
    this.isLoading = false;
    this.setDimensions();
    this.setResults();
    this.loadFromStorage();
  }

  updateDistances() {
    this.allData.forEach((x) => {
      Object.keys(this.userLocation).forEach((distanceKey) => {
        let taskLat = 0;
        let taskLng = 0;

        if (distanceKey == 'pickupDistance1') {
          taskLat = x.fromLatitude;
          taskLng = x.fromLongitude;
        } else {
          taskLat = x.toLatitude;
          taskLng = x.toLongitude;
        }

        if (!this.userLatitude[distanceKey]) {
          x[distanceKey] = null;
        } else {
          x[distanceKey] = this.vehicleAddressService.calculateDistance(
            taskLat,
            taskLng,
            this.userLatitude[distanceKey],
            this.userLongitude[distanceKey],
          );
        }
      });
    });
  }

  loadFromStorage() {
    let stored = JSON.parse(localStorage.getItem('supplier-interactive-schedule'));
    if (stored) {
      this.selectedFilters = stored;
    }

    this.setFiltersFromSelection();
  }

  changeSortBy(sortBy: number) {
    if (sortBy == this.sortby) {
      this.sortByAscending = !this.sortByAscending;
    } else {
      this.sortby = sortBy;
    }

    this.setResults();
  }

  toggleWatched(event, task) {
    event.stopPropagation();
    event.preventDefault();

    this.updatePending = task.jobId;

    if (task.supplierWatched == 'Yes') {
      this.supplierInboxjobsService.unWatchJob(task.jobId).then(() => {
        task.supplierWatched = 'No';
        this.updatePending = null;
      });
    } else {
      this.supplierInboxjobsService.watchJob(task.jobId).then(() => {
        task.supplierWatched = 'Yes';
        this.updatePending = null;
      });
    }

    return false;
  }

  filterResultSet(resultSet: IFacetedInboxTask[]) {
    return resultSet.filter((x) => x.supplierWatched == 'Yes' || this.filterWatched == false);
  }
}
